export const MARKET_TRADES_ROW_LIMIT = 30;

export const MARKET_TRADES_GRID_CLASS = "grid grid-cols-[1fr_1fr_0.7fr] gap-2";
